import { React, useEffect, useState } from "react";
import classes from "./blogspage.module.scss";
import FeaturedBlogCard from "../../generic components/main blog card/MainBlogCard";
import blogsData from "../../assets/data/blogsPageData";
import SmallBlogCard from "../../generic components/small blog card/SmallBlogCard";
import axios from "../../requests/axios";
import routes from "../../requests/routes";
import GlobeLoader from "../../layouts/globeLoader/GlobeLoader";
import Pagination from "@mui/material/Pagination";

import BlogSidebar from "./BlogSidebar/BlogSidebar";

const BlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(3);

  async function getBlogs() {
    try {
      const response = await axios.get(routes.getBlogs + "?page=" + page);
      setBlogs([]);
      setBlogs(response.data.blogs);
      setCount(Math.ceil(response.data.count / 6));
    } catch (err) {}
  }

  useEffect(() => {
    getBlogs();
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <section className={"banner"}>
        <div className={"banner__overlay"}>
          <div className={"banner__pattern"} aria-hidden="true" />
          <div className={"banner__body"}>
            <h2
              className={"banner__body__title"}
              style={{ maxWidth: "100%", whiteSpace: "nowrap" }}
            >
              Our <span>Blog</span>
            </h2>
          </div>
        </div>
      </section>
      <div className={classes.blog}>
        <div className={classes.container}>
          <div className={classes.blog__main}>
            {blogs.map((blog, index) => {
              return <SmallBlogCard key={index} blogData={blog} />;
            })}
          </div>

          <div className={classes.pagination}>
            <Pagination
              count={count}
              shape="rounded"
              page={page}
              onChange={handleChange}
              hideNextButton
              hidePrevButton
            />
          </div>
        </div>
        <BlogSidebar />
      </div>
    </>
  );
};

export default BlogsPage;
